import React, { useState, useEffect, useRef } from 'react';
import { CircleChevronRight, CircleChevronLeft, PhoneCall, House, Mail, CircleArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import '../styles/about-mnh.css';

const images = [
  require('../assets/img/carusole/img-1.jpg'),
  require('../assets/img/carusole/img-2.jpg'),
  require('../assets/img/carusole/img-3.jpg'),
];
const data = [
  {
    "id": 0,
    "title": "24 X 7 Ambulance",
    "img": require('../assets/img/icons/icon-1.png')
  },
  {
    "id": 1,
    "title": "Mediclaim Support",
    "img": require('../assets/img/icons/icon-2.png')
  },
  {
    "id": 2,
    "title": "24 X 7 CT Scan",
    "img": require('../assets/img/icons/icon-3.png')
  },
  {
    "id": 3,
    "title": "Operation Theatre",
    "img": require('../assets/img/icons/icon-4.png')
  },
  {
    "id": 4,
    "title": "24 X 7 X-RAY",
    "img": require('../assets/img/icons/icon-5.png')
  },
  {
    "id": 5,
    "title": "Dietitian Services",
    "img": require('../assets/img/icons/icon-6.png')
  }
];

const doctors_data = [
  {
    "id": 0,
    "name": "Dr. G. S. De",
    "degrees": "MBBS, MS (Surgery)",
    "timings": "Every day morning from 11 a.m. & evening from 6 p.m., except Sunday",
    "designation": "Consultant General Surgeon",
    "img": require("../assets/img/doctors/doc-1.png")
  },
  {
    "id": 1,
    "name": "Dr. Avidip De",
    "degrees": "MBBS, MS (Surgery), Fellowship: GI-HPB Surgery (Tata Medical Center) | LAP APR for cancer surgery first time out side kolkata",
    "timings": "Every day morning from 10 a.m. & evening from 6 p.m. except Sunday",
    "designation": "Consultant Laparoscopic & GI Onco-Surgeon",
    "img": require("../assets/img/doctors/doc-2.png")
  },
  {
    "id": 2,
    "name": "Dr. Abhijit Das",
    "degrees": "Achievements: Gold Medalist Additional Qualifications: DNB, ECMO, CEPIC, PDCR, MNAMSFellowship: Clinical Oncology (Tata Medical Center)",
    "timings": "Every Sunday from 11 a.m",
    "designation": "Consultant Medical & Radiation Oncologist",
    "img": require("../assets/img/doctors/doc-3.png")
  },
  {
    "id": 3,
    "name": "Dr. Avisek De",
    "degrees": "MBBS, MD (Radiodiagnosis)",
    "timings": "Every day morning 8 a.m. to 2 p.m. except Sunday",
    "designation": "Consultant Radiologist",
    "img": require("../assets/img/doctors/doc-4.png")
  },
  {
    "id": 4,
    "name": "Dr. Barun Saha",
    "degrees": "MBBS, MS, MCh (Urology)",
    "timings": "Last Thursday of every month from 6 p.m. (with prior appointment)",
    "designation": "Consultant Uro-Surgeon, PCNL, URSL, TURP",
    "img": require("../assets/img/doctors/doc-5.png")
  },
  {
    "id": 5,
    "name": "Dr. D. P. Das",
    "degrees": "MBBS, MS, MCh (Urology)",
    "timings": "2nd & 4th Sunday every month from 8 a.m. (with prior appointment)",
    "designation": "Consultant Uro-Surgeon",
    "img": require("../assets/img/doctors/doc-6.png")
  },
  {
    "id": 6,
    "name": "Dr. Partha Chakraborty",
    "degrees": "MBBS, MS, MCh (Paediatric Surgery)",
    "timings": "Every Sunday from 10 a.m.",
    "designation": "Consultant Paediatric Surgeon, Consultant Hypospadias Orchidopexy",
    "img": require("../assets/img/doctors/doc-7.png")
  },
  {
    "id": 7,
    "name": "Dr. Rana Barik",
    "degrees": "MBBS, MD (Pulmonary Medicine)",
    "timings": "Every Tuesday from 1 p.m.",
    "designation": "Consultant Pulmonologist",
    "img": require("../assets/img/doctors/doc-8.png")
  },
  {
    "id": 8,
    "name": "Dr. Monoranjan Sow",
    "degrees": "MBBS, MS (Surgery) Fellowship: MCh (Plastic & Reconstructive Surgery) Achievements: Gold Medalist",
    "timings": "Every Sunday from 10 a.m.",
    "designation": "Consultant Plastic & Reconstructive Surgeon",
    "img": require("../assets/img/doctors/doc-9.png")
  },
  {
    "id": 9,
    "name": "Dr. Snehasis Ghosh",
    "degrees": "MD (Medicine), Dip. Card. (Cardiology)",
    "timings": "Every Tuesday & Friday from 8 a.m.",
    "designation": "Consultant General Physician & Cardiologist",
    "img": require("../assets/img/doctors/doc-10.png")
  },
  {
    "id": 10,
    "name": "Dr. Somenath Das",
    "degrees": "MBBS, MD (Dermatology)",
    "timings": "Every Thursday & Saturday from 1 p.m.",
    "designation": "Consultant Dermatologist",
    "img": require("../assets/img/doctors/doc-11.png")
  },
  {
    "id": 11,
    "name": "Dr. Ranbir Singh",
    "degrees": "MBBS, MD (Pathology) Fellowship: DM (Onco-Pathology) (Tata Medical Center)",
    "timings": "Every Sunday from 1 p.m.",
    "designation": "Consultant Pathologist",
    "img": require("../assets/img/doctors/doc-12.png")
  },
  {
    "id": 12,
    "name": "Dr. Jitamanyu Maity",
    "degrees": "MBBS (Kol), DPM (IPGMER), MIPS",
    "timings": "By appointment",
    "designation": "Consultant Neuro Psychiatrist | Ex-Calcutta National Medical College, Kol. | Ex-Attached to IIMSAR & BC Roy Hospital | Haldia Antara Neuro Psychiatry Hospital (Kol)",
    "img": require("../assets/img/doctors/doc-13.png")
  },
  {
    "id": 13,
    "name": "Dr. Dalliya Roy",
    "degrees": "MBBS, MS (Gynaec & Obs)",
    "timings": "Every Monday to Wednesday, by appointment",
    "designation": "Consultant Obstetrician & Gynaecologist",
    "img": require("../assets/img/doctors/doc-14.png")
  },
  {
    "id": 14,
    "name": "Sritama Banerjee",
    "degrees": "B.Sc, M.Sc (Medical Nutritional Therapy)",
    "timings": "By appointment",
    "designation": "Consultant Clinical Dietitian, Nutritionist & Diabetes Educator",
    "img": require("../assets/img/doctors/doc-15.png")
  }
];
const service_types = [
  {
    "id": 0,
    "title": "General Surgery",
    "description": "General surgery involves the diagnosis and surgical treatment of common conditions affecting the abdomen, digestive system, soft tissues, and related areas...",
    "img": require("../assets/img/services/thumb-1.png")
  },
  {
    "id": 1,
    "title": "Laparoscopic & GI Surgery",
    "description": "Laparoscopic and gastrointestinal surgeries use minimally invasive techniques to treat conditions of the digestive system...",
    "img": require("../assets/img/services/thumb-2.png")
  },
  {
    "id": 2,
    "title": "Onco-Surgery",
    "description": "Onco-surgery focuses on the surgical management of cancer...",
    "img": require("../assets/img/services/thumb-3.png")
  },
  {
    "id": 3,
    "title": "Plastic & Reconstrucive Surgery",
    "description": "This specialty addresses the repair and reconstruction of tissues affected by injury...",
    "img": require("../assets/img/services/thumb-4.png")
  },
  {
    "id": 4,
    "title": "Pediatric Surgery",
    "description": <>Paediatric surgery provides surgical care for infants and children. <b className="blink-text">Hypospadias &amp; Orchidopexy 1st Time in Birbhum, Bolpur</b></>,
    "img": require("../assets/img/services/thumb-5.png")
  },
  {
    "id": 5,
    "title": "Uro - Surgery",
    "description": <>Urological surgery treats conditions of the urinary system and male/female reproductive organs. <b className="blink-text">PCNL & TURP 1st in Birbhum</b></>,
    "img": require("../assets/img/services/thumb-6.png")
  }
];


const patientResponsibilities = [
  "Provide accurate information about your health condition, medical history, and medications to healthcare providers.",
  "Follow the prescribed treatment, take medicines as directed, and comply with the instructions of healthcare professionals.",
  "Respect the rights of patients and hospital staff, maintain courtesy, and follow hospital rules and regulations.",
  "Patients and their relatives should stay informed, ask questions, understand the condition, and participate in healthcare decisions.",
  "Be completely honest while sharing past medical history, personal habits, current problems, and family medical history.",
  "Inform healthcare providers about allergies, previous medical problems, external medical opinions, and outside medical records (if any).",
  "Patients should participate in decision-making, maintain regular communication with doctors, and sincerely follow the complete treatment plan.",
  "Avoid violent or abusive behavior towards hospital staff, hospital property, and other patients.",
  "Provide correct patient details such as full name, age, address, etc., and provide medical insurance information when required.",
  "If the patient is a registered organ donor, the healthcare provider must be informed.",
  "Patients should take proper care of their belongings while staying in the hospital or healthcare center.",
  "Keep your appointments or inform the hospital if there are any changes.",
  "Follow infection control and safety policies."
];

function Home() {
  const [current, setCurrent] = useState(0);
  const timeoutRef = useRef(null);
  const [showModal, setShowModal] = useState(true);

  // Responsive icon size
  const [iconSize, setIconSize] = useState(48);
  const [showArrows, setShowArrows] = useState(true);
  const [aboutItems, setAboutItems] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const [serviceTypes, setServiceTypes] = useState([]);
  // Find the index of the doctor with id === 0
  const initialDoctorIndex = doctors_data.findIndex(doc => doc.id === 0);
  const [carouselIndex, setCarouselIndex] = useState(initialDoctorIndex >= 0 ? initialDoctorIndex : 0);
  const [animationDirection, setAnimationDirection] = useState('in'); // 'in' or 'out'
  const carouselIntervalRef = useRef(null);

  // Number of cards per slide
  const [cardsPerSlide, setCardsPerSlide] = useState(3);

  const navigate = useNavigate();

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 600) {
        setIconSize(28);
        setShowArrows(false);
        setCardsPerSlide(1);
      } else if (window.innerWidth <= 900) {
        setIconSize(36);
        setShowArrows(true);
        setCardsPerSlide(2);
      } else {
        setIconSize(48);
        setShowArrows(true);
        setCardsPerSlide(3);
      }
    }
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const nextSlide = () => setCurrent((prev) => (prev + 1) % images.length);
  const prevSlide = () => setCurrent((prev) => (prev - 1 + images.length) % images.length);

  useEffect(() => {
    timeoutRef.current = setTimeout(nextSlide, 3500);
    return () => clearTimeout(timeoutRef.current);
  }, [current]);

  useEffect(() => {
    //console.log('JSON Data:', aboutItems)
    setAboutItems(data);
    setServiceTypes(service_types);
    setDoctors(doctors_data);
  }, []);


  // Carousel animation loop (right to left)
  useEffect(() => {
    if (!doctors.length) return;
    carouselIntervalRef.current = setInterval(() => {
      setAnimationDirection('out');
      setTimeout(() => {
        setCarouselIndex(prev => (prev + cardsPerSlide) % doctors.length);
        setAnimationDirection('in');
      }, 350); // pan out duration
    }, 3500);
    return () => clearInterval(carouselIntervalRef.current);
  }, [doctors, cardsPerSlide]);

  // Get visible doctors for current slide
  const getVisibleDoctors = () => {
    if (!doctors.length) return [];
    let visible = [];
    for (let i = 0; i < cardsPerSlide; i++) {
      visible.push(doctors[(carouselIndex + i) % doctors.length]);
    }
    return visible;
  };

  return (
    <>
      {showModal && (
        <div className="pr-modal-overlay" onClick={() => setShowModal(false)}>
          <div className="pr-modal" onClick={e => e.stopPropagation()}>
            <div className="pr-modal-header">
              {/* <img src={require('../assets/img/logo_transparent.png')} alt="logo" className="pr-header-logo" /> */}
              <h2 className="pr-modal-title">Patient Responsibilities</h2>
              {/* <img src={require('../assets/img/logo_transparent.png')} alt="logo" className="pr-header-logo" /> */}
              <button className="pr-modal-close" onClick={() => setShowModal(false)} aria-label="Close">&times;</button>
            </div>
            <div className="pr-modal-divider" />
            <div className="pr-modal-body">
              <ul className="pr-modal-list">
                {patientResponsibilities.map((item, idx) => (
                  <li key={idx} className="pr-modal-list-item">
                    <span className="pr-bullet">&bull;</span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      )}
      <div className="homeCarousel">
        <div className="carousel-slider">
          <div className="carousel-images carousel-images-relative">
            {showArrows && (
              <button className="carousel-btn left carousel-btn-absolute" onClick={prevSlide} aria-label="Previous">
                <CircleChevronLeft size={iconSize} />
              </button>
            )}
            {images.map((img, idx) => (
              <img
                key={idx}
                src={img}
                alt={`carousel-${idx}`}
                className={`carousel-img${idx === current ? ' active' : ''}`}
                draggable="false"
              />
            ))}
            {showArrows && (
              <button className="carousel-btn right carousel-btn-absolute" onClick={nextSlide} aria-label="Next">
                <CircleChevronRight size={iconSize} />
              </button>
            )}
            <div className="carousel-title-overlay" style={{ top: '45%' }}>
              <h1>Trusted Healthcare for Every Stage of Life</h1>
              <p style={{ fontWeight: 'normal', fontSize: '40px', color: '#FFFFFF', textAlign: 'center' }}>Providing diagnostic, medical,
                and surgical care in
                Suri, Birbhum since 2002.</p>
            </div>
            <div className="carousel-title-overlay-2">

            </div>
            {/* <div className="gallery-overlay-title" style={{ top: '70%' }}>
              Trusted Healthcare for Every Stage of Life
              <p style={{ fontWeight: 'normal', fontSize: '40px', color: '#FFFFFF', textAlign: 'center' }}>Providing diagnostic, medical,
                and surgical care in
                Suri, Birbhum since 2002.</p>
            </div> */}
          </div>
        </div>
      </div>
      <div className="home-carousel-row">
        <div className="home-carousel-col">
          <div className="carousel-col-content">
            <PhoneCall size={48} color="#fff" />
            <span className="carousel-col-title">
              In Emergency give us a call<br />
              9434007688
            </span>
          </div>
        </div>
        <div className="home-carousel-col">
          <div className="carousel-col-content">
            <House size={48} color="#fff" />
            <span className="carousel-col-title">
              Get our Location<br />
              Dangalpara, Suri, Birbhum
            </span>
          </div>
        </div>
        <div className="home-carousel-col">
          <div className="carousel-col-content">
            <Mail size={48} color="#fff" />
            <span className="carousel-col-title">
              Send an email<br />
              mdnhsuribir@gmail.com
            </span>
          </div>
        </div>
      </div>
      <section className="about-mnh-section">
        <div className="about-mnh-badge about-mnh-badge-align-left">
          <span className="about-mnh-badge-text">About Us</span>
        </div>
        <h1>Modern Diagnostics & Nursing Home Pvt. Ltd. is a healthcare facility located in Dangalpara, Suri, Birbhum. Established in 2002, we have been providing diagnostic, medical, and surgical care to patients for over two decades.</h1>
        <p>
          At Modern Diagnostics & Nursing Home Pvt. Ltd., we offer outpatient (OPD) consultations, diagnostic services, and a range of medical and surgical treatments.
        </p>
        <div className='serviceType serviceType-row'>
          {Array.isArray(aboutItems) && aboutItems.length > 0 ? (
            aboutItems.map((item, index) => (
              <div className="serviceType-col" key={item.id || item.title}>
                <img src={item.img} alt={item.title} />
                <span>{item.title}</span>
              </div>
            ))
          ) : null}
        </div>
        <div>
          <button
            className='btn-knowmore'
            onClick={() => navigate('/about')}
          >
            KNOW MORE...<CircleArrowRight size={24} color="#fff" />
          </button>
        </div>
      </section>
      <section className="about-mnh-section">
        <div className="doctor-mnh-badge doctor-mnh-badge-align-left">
          <span className="doctor-mnh-badge-text">Our Doctors</span>
        </div>
        <div className="doctorType doctorCarousel-row" style={{ overflow: 'hidden', width: '100%' }}>
          {getVisibleDoctors().map((doctor, idx) => (
            <div
              className="doctor-card"
              key={doctor.id + '-' + carouselIndex + '-' + animationDirection}
              style={{
                background: '#c4cdd3',
                borderRadius: '8px',
                padding: '24px 16px',
                margin: '0 8px',
                minWidth: 0,
                width: `calc((100% - ${(cardsPerSlide - 1) * 16}px) / ${cardsPerSlide})`,
                flex: '1 1 0',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                opacity: 1,
                animation: animationDirection === 'in' ? 'doctorCardFadeIn 0.9s' : 'doctorCardFadeOut 0.5s',
              }}
            >
              <img
                src={doctor.img}
                alt={doctor.name}
                className='doctor-images'
                style={{
                  width: window.innerWidth <= 400 ? 200 : 300 || window.innerWidth <= 1000 ? 240 : 300,
                  height: window.innerWidth <= 400 ? 200 : 300 || window.innerWidth <= 1000 ? 240 : 300,
                }}
              />
              <h1>{doctor.name}</h1>
              <span>{doctor.degrees}</span>
              <span>{doctor.designation}</span>
              <span>{doctor.timings}</span>
            </div>
          ))}
        </div>
        <div>
          <button
            className='btn-knowmore'
            onClick={() => navigate('/doctors')}
          >
            KNOW MORE...<CircleArrowRight size={24} color="#fff" />
          </button>
        </div>
      </section>
      <section className="about-mnh-section" style={{ backgroundColor: '#dbedf8', borderRadius: '8px', marginBottom: '40px', padding: '5px', paddingBottom: '80px' }}>
        <div>
          <h1 style={{ textAlign: 'center' }}>High quality Care And Patient Safety!!</h1>
          <div className='serv-Type  serviceType-row-center'>
            {Array.isArray(serviceTypes) && serviceTypes.length > 0 ? (
              serviceTypes.map((item, index) => (
                <div className="card" style={{
                  width: 400,
                  padding: '16px',
                }} key={item.id || item.title}>
                  <img src={item.img} alt={item.title}
                    style={{
                      width: 250,
                      height: 250,
                      marginTop: '16px',
                      borderRadius: '8px',
                      objectFit: 'cover',
                      display: 'block',
                      margin: '0 auto'
                    }} />
                  <span><h1>{item.title}</h1></span>
                  <span><p>{item.description}</p></span>
                </div>
              ))
            ) : null}
          </div>
        </div>
      </section>
      <section className="patient-voice-section" style={{ backgroundColor: '#0d256d', marginBottom: '40px', padding: '5px' }}>
        <div className="voice-overlay-row" style={{ width: 'auto' }}>
          <h1 style={{ width: '100%', textAlign: 'center', margin: 0 }}>Patient's Voice</h1>
        </div>
        <div className="voice-overlay-row" style={{ width: 'auto' }}>
          <TextCarousel />
        </div>
        .
      </section>
    </>
  );
}



// --- Add TextCarousel component below Home() ---

const textSlides = [
  {
    img: require('../assets/img/illustration-1.png'),
    title: "Anonymous Patient | General Surgery",
    body: "“I came to the hospital with severe abdominal pain and was extremely anxious about surgery. The doctors explained the procedure clearly and answered all my questions. The surgery was planned properly, and the nursing staff supported me throughout recovery. I was able to return home sooner than I expected under medical guidance.”"
  },
  {
    img: require('../assets/img/illustration-2.png'),
    title: "Anonymous Patient | Diagnostic Services",
    body: "“The diagnostic tests were done smoothly and without confusion. Reports were available on time, which helped the doctor start treatment without delay. The staff explained the process patiently, which made the experience less stressful for me and my family.”"
  },
  {
    img: require('../assets/img/illustration-1.png'),
    title: "Anonymous Patient | Laparoscopic Surgery",
    body: "“I was advised minimally invasive surgery and was worried about the process. The doctors explained what to expect before and after the procedure. Recovery was monitored carefully, and I felt supported throughout my hospital stay.”"
  },
  {
    img: require('../assets/img/illustration-2.png'),
    title: "Anonymous Patient | Cancer Care Support",
    body: "“When I was diagnosed with a serious condition, I was overwhelmed. The medical team guided me step by step and coordinated care properly. Clear communication and regular monitoring helped me manage the treatment process with confidence.”"
  },
  {
    img: require('../assets/img/illustration-1.png'),
    title: "Anonymous Patient | Inpatient Care",
    body: "“During my hospital stay, the nursing staff was attentive and responsive. Medicines were given on time, and doctors checked on my condition regularly. The overall environment felt organised and reassuring during recovery.”"
  }
];

function TextCarousel() {
  const [index, setIndex] = useState(0);
  const [animating, setAnimating] = useState(false);
  const [direction, setDirection] = useState('in'); // 'in' or 'out'
  const timeoutRef = useRef(null);

  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      setDirection('out');
      setAnimating(true);
      setTimeout(() => {
        setIndex((prev) => (prev + 1) % textSlides.length);
        setDirection('in');
        setAnimating(true);
      }, 350); // fade out duration
    }, 3000);
    return () => clearTimeout(timeoutRef.current);
  }, [index]);

  // Reset animating after animation
  useEffect(() => {
    if (animating) {
      const timer = setTimeout(() => setAnimating(false), 350);
      return () => clearTimeout(timer);
    }
  }, [animating]);

  return (
    <div className="text-carousel-container" style={{ overflow: 'hidden' }}>
      <div
        className={`text-carousel-slide`}
        style={{
          animation: animating
            ? direction === 'in'
              ? 'textCarouselFadeInRight 0.35s'
              : 'textCarouselFadeOutLeft 0.35s'
            : 'none'
        }}
      >
        <span><img src={textSlides[index].img} alt="Patient testimonial" style={{ width: '108px', height: 'auto' }} /></span>
        <span>{textSlides[index].title}</span>
        {textSlides[index].body && (
          <span style={{ fontSize: 16, color: '#fff', marginTop: 8, display: 'block', textAlign: 'center', fontWeight: 'normal' }}>
            {textSlides[index].body}
          </span>
        )}
      </div>
      <div className="text-carousel-dots">
        {textSlides.map((_, i) => (
          <span
            key={i}
            className={`text-carousel-dot${i === index ? ' active' : ''}`}
            onClick={() => {
              if (i !== index) {
                setDirection('out');
                setAnimating(true);
                setTimeout(() => {
                  setIndex(i);
                  setDirection('in');
                  setAnimating(true);
                }, 350);
              }
            }}
          />
        ))}
      </div>
    </div>
  );
}

// Add or update the style injection for TextCarousel responsive font size
const style = document.createElement('style');
style.innerHTML = `
/* Patient Responsibilities Modal */
.pr-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(10, 30, 80, 0.55);
  z-index: 9999;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 80px;
  backdrop-filter: blur(3px);
  animation: prOverlayFadeIn 0.3s;
}
@keyframes prOverlayFadeIn {
  from { opacity: 0; }
  to   { opacity: 1; }
}
.pr-modal {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 8px 48px rgba(13, 37, 109, 0.22);
  width: 90%;
  max-width: 680px;
  max-height: 78vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: prModalSlideIn 0.35s cubic-bezier(.25,.8,.25,1);
}
@keyframes prModalSlideIn {
  from { transform: translateY(-30px); opacity: 0; }
  to   { transform: translateY(0);     opacity: 1; }
}
.pr-modal-header {
  background: linear-gradient(90deg, #0b6e4f 0%, #12a06e 100%);
  padding: 14px 16px 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.pr-header-logo {
  width: 52px;
  height: 52px;
  object-fit: contain;
  flex-shrink: 0;
  filter: drop-shadow(0 2px 6px rgba(0,0,0,0.35));
}
.pr-modal-title {
  color: #fff;
  font-size: 32px;
  font-weight: 700;
  margin: 0;
  letter-spacing: 0.5px;
  text-align: center;
  flex: 1;
  text-shadow: 0 1px 4px rgba(0,0,0,0.25);
}
.pr-modal-close {
  background: rgba(255,255,255,0.18);
  border: none;
  color: #fff;
  font-size: 26px;
  line-height: 1;
  cursor: pointer;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  flex-shrink: 0;
}
.pr-modal-close:hover { background: rgba(255,255,255,0.35); }
.pr-modal-divider {
  height: 3px;
  background: linear-gradient(90deg, #0b6e4f, #12a06e, #5ddba8);
}
.pr-modal-body {
  overflow-y: auto;
  padding: 20px 28px 24px 28px;
  flex: 1;
}
.pr-modal-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.pr-modal-list-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 15px;
  color: #1a2a4a;
  line-height: 1.6;
}
.pr-bullet {
  color: #0b6e4f;
  font-size: 22px;
  line-height: 1.4;
  flex-shrink: 0;
  font-weight: bold;
}
@media (max-width: 600px) {
  .pr-modal { max-height: 85vh; }
  .pr-modal-body { padding: 14px 14px 18px 14px; }
  .pr-modal-list-item { font-size: 13px; }
  .pr-header-logo { width: 38px; height: 38px; }
  .pr-modal-title { font-size: 17px; }
}
@keyframes blinker {
  50% { opacity: 0; }
}
.blink-text {
  animation: blinker 1s linear infinite;
  color: #d32f2f;
}

@keyframes doctorCardFadeIn {
  0% { opacity: 0; }
  100% { opacity: 1; }
}
@keyframes doctorCardFadeOut {
  0% { opacity: 1; }
  100% { opacity: 0; }
}
/* Text Carousel Styles */
.text-carousel-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 12px;
}
.text-carousel-slide {
  min-height: 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.text-carousel-slide span {
  font-size: 30px;
  color: #fff;
  text-align: center;
  display: block;
  width: 90%;
  font-weight: 500;
  letter-spacing: 0.5px;
  transition: opacity 0.5s;
}
.text-carousel-dots {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  gap: 8px;
}
.text-carousel-dot {
  width: 10px;
  height: 10px;
  background: #fff;
  opacity: 0.5;
  border-radius: 50%;
  display: inline-block;
  cursor: pointer;
  transition: opacity 0.3s, background 0.3s;
  border: 2.5px solid #fff;
  box-sizing: border-box;
}
.text-carousel-dot.active {
  opacity: 1;
  background: #fff;
  border: 2.5px solid #fff;
}
/* Fade left-to-right animation */
@keyframes textCarouselFadeInRight {
  0% { opacity: 0; transform: translateX(-40px);}
  100% { opacity: 1; transform: translateX(0);}
}
@keyframes textCarouselFadeOutLeft {
  0% { opacity: 1; transform: translateX(0);}
  100% { opacity: 0; transform: translateX(40px);}
}
/* Responsive font size for mobile */
@media (max-width: 600px) {
  .text-carousel-slide span {
    font-size: 18px !important;
  }
  .text-carousel-slide span img {
    width: 72px !important;
    height: auto !important;
  }
}
`;
document.head.appendChild(style);

export default Home;
